import React from 'react';
import DailyCheckinCard from '../../DailyCheckinCard';

/**
 * DailyCheckinFormCard — chat-thread version of the unified daily check-in.
 *
 * Reuses the same component as the Mental page so behaviour is identical:
 * tap mood/stress/sleep/pain/energy/hunger → Save → snapshot view → Mental IQ
 * appears. Pre-fills from `data.prefill` (latest check-in) when the user
 * came in via the chat chip.
 */
const DailyCheckinFormCard = ({ data }) => (
  <div className="max-w-md">
    <DailyCheckinCard
      initialPrefill={data?.prefill}
      forceForm={!data?.has_today}
    />
  </div>
);

export default DailyCheckinFormCard;
